<template>
  <div class="crop-and-upload" >
    <drop-file
      v-if="uploading"
      key="upload-image"
      :multiple="false"
      :maxFileSize="4"
      :style="{backgroundColor: 'white'}"
      class="dialog-drop-file"
      accept="image/*"
      @filesChanged="data => {
        formData = data
        uploading = false
        $store.dispatch('dialog/setTitle', 'Crop the image')
      }" />
    <cropper
      v-else
      key="crop-image"
      @cropperLoaded="cropperLoadedHandler"
      :file="file" />
  </div>
</template>

<script>
  import DropFile from '~/components/common/DropFile.vue'
  import Cropper from '~/components/common/Cropper.vue'

  export default {
    name: 'crop-image',
    components: {DropFile, Cropper},
    data () {
      return {
        uploading: true,
        formData: null
      }
    },
    destroyed () {
      this.uploading = true
    },
    methods: {
      cropperLoadedHandler (cropper) {
        this.$store.dispatch('dialog/setActions', {
          cancel: {},
          accept: {
            callback: () => {
              cropper.getCroppedCanvas().toBlob(blob => {
                const file = this.formData.getAll('files')[0]
                this.$upload({
                  endpoint: 'account/' + this.$store.state.session.accountId + '/avatar',
                  files: new File([blob], file.name, {type: file.type})
                }).then(response => {
                  this.$store.dispatch('session/avatarUpdated')
                }).catch(error => {
                  this.$store.dispatch('feedback/addSnack', {text: error.message})
                })
              }, this.file.type, 1)
            }
          }
        })
      }
    },
    computed: {
      file () {
        return this.formData.get('files')
      }
    }
  }
</script>

<style lang="scss">

  .crop-and-upload {

    .dialog-drop-file .drop-box {
      transition: none !important;
      padding: 3rem 0 3rem 0 !important;

      &.has-files {
        padding: 3rem 0 1rem 0 !important;
      }
    }

    .cropper-view-box,
    .cropper-face,
    .cropper-move {
      border-radius: 50%;
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/common/dialog/types/DialogCropAndUploadAvatar.vue